module.exports = __webpack_public_path__ + "static/media/chevron-left.4778ea7b.svg";